import styled from 'styled-components';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

export function TdDestinationInfo({
    returnExchange
}) {
    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div>주소: {returnExchange?.destination || '-'}</div>
                    <div>주소상세: {returnExchange?.destinationDetail || '-'}</div>
                </div>
            </StyledTableCell>
        </>
    );
}